import {action, makeObservable, runInAction} from "mobx";
import {BaseListStore} from "app/modules/common/stores/BaseListStore";
import {inject} from "react-ioc";
import {AdminApiClients} from "app/modules/admin/services/AxiosBaseClient";
import {
    DataListGetParamsOfTenantAdminListFilters,
    TenantAdminListFilters,
    TenantAdminListModel
} from "app/modules/admin/api/clients.api";
import {FieldState, FormState} from "formstate";

export class TenantsStore extends BaseListStore<TenantAdminListModel> {
    @inject adminApiClients: AdminApiClients;

    filters = new FormState({
        search: new FieldState('')
    })

    constructor() {
        super();

        makeObservable(this, {
            init: action
        });
    }

    applySpecificFilters() {
    }

    async loadData() {
        this.wrapLoadingApiCall(async () => {
            let filters = new TenantAdminListFilters({search: this.filters.$.search.value});
            const [result] = await Promise.all([
                this.adminApiClients.tenantManagementClient.getTenants(new DataListGetParamsOfTenantAdminListFilters({
                    offset: this.skipRows,
                    pageSize: this.pageSize,
                    filter: filters
                }))
            ]);

            this.items = result.items;
            this.totalRows = result.count;

        });
    }

    async init() {
        await this.loadData();

        runInAction(() => {
            this.isInitLoading = false;
        })
    }
}
